__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-account-copy-lib/v3_2_1/";